import { TelemetryEventType } from '../telemetry/telemetry-models';

export type ActionType = 'CLICK_BUTTON' | 'CLICK_FILTER' | 'CLICK_SEARCH' | string;
export type ActionEventParameters = { [k: string]: string | number | boolean | Array<unknown> | ActionEventParameters };
export interface DataInsightPageLoadContent {
  list_values?: unknown[];
  filters?: unknown;
  form_data?: unknown;
  parameters?: unknown;
  metrics?: {
    num_of_list_values: number;
  };
}

export interface PageMeta {
  pagename: string;
  pagegroup: string;
}
export interface ActionEventParams {
  pageelement: string;
  action_subtype: string;
  action_type?: ActionType;
  parameters?: ActionEventParameters;
}

export interface HeartBeatEventParams extends PageMeta {
  course_id: number;
  module_id: number;
  span_ms: number;
}

export type PageViewParams = PageMeta;
export interface PageLoadParams {
  page_contents?: object;
}

/**  Insights event types for analytics and user behavior tracking */
export enum InsightsEventType {
  PAGE_VIEW = 'view',
  PAGE_LOAD = 'load',
  CLICK_EVENT = 'click',
  HEARTBEAT = 'heartbeat',
}

/**  Combined event type for all internal events (Kafka message type) */
export const InternalEventType = { ...InsightsEventType, ...TelemetryEventType } as const;
export type InternalEventType = InsightsEventType | TelemetryEventType;
interface BaseEventRequest {
  pageviewId: string;
  unixtimestamp: number;
  type: InternalEventType;
  url_path: string;
}
export interface ActionEvent extends BaseEventRequest {
  origin: {
    pageelement: string;
    pagegroup: string;
    pagename: string;
  };
  parameters: ActionEventParameters;
  action_subtype: string;
  action_type: ActionType;
}
export interface PageViewEvent extends BaseEventRequest {
  page: PageMeta;
}
export interface PageLoadEvent extends BaseEventRequest {
  page: PageMeta;
  page_contents?: DataInsightPageLoadContent;
}

export interface TelemetryEventWrapper extends BaseEventRequest {
  telemetry: unknown;
  timestamp: number;
}

export type TrackEvent = ActionEvent | PageViewEvent | PageLoadEvent | HeartbeatEvent | TelemetryEventWrapper;

export interface HeartbeatEvent extends BaseEventRequest {
  page: PageMeta;
  course_id: number;
  module_id: number;
  span_ms: number;
}
/** Mimic the NavigationEnd event from Angular router */
export interface NavigationEnd {
  /** A unique ID that the router assigns to every router navigation. */
  id: number;
  /** The URL that is the destination for this navigation. */
  url: string;

  /** Router event type */
  readonly type: 1; // EventType.NavigationEnd
}
